module.exports = __webpack_public_path__ + "static/media/banner-redes.b126ca30.png";